import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatError, MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LoginHeaderComponent } from '../../shared/components/login-header/login-header.component';
import { FooterComponent } from '../../shared/components/app-footer/footer.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../core/services/Login/login.service';
import { AesEncDecService } from '../../core/services/aes/aes-enc-dec.service';
import { CustomErrorStateMatcher } from '../../core/models/CustomErrorStateMatcher';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../shared/components/dialogbox/dialog/dialog.component';
import { ResponseVm } from '../../core/models/response-vm';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    CommonModule,
    MatLabel,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatFormField,
    MatError,
    MatInputModule,
    MatButtonModule,
    LoginHeaderComponent,
    FooterComponent
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent implements OnInit {
  private router = inject(Router);
  loginService = inject(LoginService);
  localStorage = inject(AesEncDecService);
  matcher = new CustomErrorStateMatcher();
  dialog = inject(MatDialog);
  loginFailedMessage: string;
  resetForm: FormGroup;
  formValues: any;
  userid: string;
  otp: string;
  private route = inject(ActivatedRoute);
  error_messages = {
    'password': [
      { type: 'required', message: 'password is required.' },
      { type: 'minlength', message: 'Password must be at least 10 characters long.' },
      { type: 'maxlength', message: 'Password cannot be more than 30 characters long.' }
    ],
    'reEnterPassword': [
      { type: 'required', message: 'confirm password is required.' },
      { type: 'minlength', message: 'Password must be at least 10 characters long.' },
      { type: 'maxlength', message: 'Confirm password cannot be more than 30 characters long.' },

      { type: 'passwordNotMatch', message: 'Passwords do not match.' }
    ],
  }
  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const reEnterPassword = formGroup.get('reEnterPassword')?.value;
    return password === reEnterPassword ? null : { passwordNotMatch: true };
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.userid = params['UserID'];
      this.otp = params['OTP'];
    });
    this.loginService.verifyPassword(this.userid, this.otp).subscribe({
      next: (response: any) => {
        if (response.responseCode === "1000") {
          // this.forgotPasswordForm.reset();
          this.resetForm.get('userID')?.setValue(response.userId);
          // this.dialog.open(DialogComponent, {
          //   data: {
          //     title: 'Success',
          //     message: response.responseMessage
          //   }
          // });
        } else {
          this.dialog.open(DialogComponent, {
            data: {
              title: 'Error',
              message: response.responseMessage
            }
          });
        }
      },
      error: error => {
        this.dialog.open(DialogComponent, {
          data: {
            title: 'Error',
            message: "Invalid user Id or OTP. Please reinitiate the forgot passowrd process again."
          }
        });
      }
    })
    // const userID = JSON.parse(this.localStorage?.getData("loginUserId")?.toString() || '{}');
    // this.resetForm.get('userID')?.setValue(userID);
  }
  constructor(private fb: FormBuilder) {

    this.resetForm = this.fb.group({
      userID: new FormControl({ value: '', disabled: true }, Validators.required),
      password: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(30)
      ])),
      reEnterPassword: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(30)
      ])),
    }, {
      validators: this.passwordMatchValidator
    });

  }
  onSubmit() {
    this.resetForm.get('userID')?.enable();
    this.formValues = this.resetForm.value;
    // Disable the userId field again
    this.resetForm.get('userID')?.disable();

    this.loginService.updatePassword(this.formValues).subscribe({
      next: (response: ResponseVm) => {
        if (response.responseCode === "1000") {   
          this.dialog.open(DialogComponent, {
            data: {
              title: 'Success',
              message: response.responseMessage
            }
          });
          this.router.navigateByUrl('login');
        } else {
          this.dialog.open(DialogComponent, {
            data: {
              title: 'Error',
              message: response.responseMessage
            }
          });
        }
        

      },
      error: error => {
        this.loginFailedMessage = error.error.ResponseMessage;
        console.error('There was an error!', error);
      }
    });
  }

}
